import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {PatronActions} from '@store/patron/patron.actions';
import {Store} from '@ngrx/store';

@Component({
  selector: 'px-logout',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class LogoutComponent implements OnInit {
  private router = inject(Router);
  private store = inject(Store);

  ngOnInit(): void {
    // log the person out
    this.store.dispatch(PatronActions.logoutPatron());
  }
}
